import { render, staticRenderFns } from "./addMerchantShop.vue?vue&type=template&id=1cd66f74"
import script from "./addMerchantShop.vue?vue&type=script&lang=js"
export * from "./addMerchantShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports